import styles from './App.module.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation
} from 'react-router-dom'

import Landing from './views/Landing'
import SignUp from './views/SignUp';
import Sidebar from './compoenets/Sidebar';
import Header from './compoenets/Header';
import Callback from './views/Callback';
import Experiment from './views/Experiment';
import Dashboard from './views/Dashboard';
import Playground from './views/Playground';
import TaskEval from './views/TaskEval';
import DeviceTimeline from './views/DeviceTimeline';

const ROUTER=[
  { path:'callback', element:<Callback/>},
  { path:'sign-up', element:<SignUp/>},
  { path:'dashboard', element:<Dashboard/>},
  { path:'task-evaluation', element:<TaskEval/>},
  { path:'device-timeline', element:<DeviceTimeline/>},
  { path:'playground', element:<Playground/>},
  { path:'experiment', element:<Experiment/>},
  // { path:'*', element:<PageNotFound/>},
]

export default function App() {
  const location = useLocation();

  return (
    <div className={styles['App']}>
      {location.pathname !== '/' && location.pathname !== '/sign-up' && location.pathname !== '/callback'&&<>
      {/* <Header className={styles['header']}/> */}
      <Sidebar className={styles['sidebar']}/>
      </>}
      <div className={`${styles['main']} ${(location.pathname === '/' || location.pathname === '/sign-up') && styles['landing']}`}>
        <Routes>
          {/* <Route index element={<Landing/>} /> */}
          <Route index element={<Landing/>} />
          {ROUTER.map(({path,element})=>(
            <Route path={path} element={element}></Route>
          ))}
        </Routes>
      </div>
    </div>
  );
}